import React, { type FC, useState, useEffect } from 'react'
import { styled } from '@linaria/react'
import { useToast, ANIMATION_DURATION_MS } from '../contexts/ToastContext'
import { Typography } from './Typography'
import { colors } from '../styles/colors'
import { useViewport } from '../hooks/useViewport'

const ANIMATION_DURATION_S = `${ANIMATION_DURATION_MS / 1000}s`

export const Toast: FC = () => {
  const { toast, isVisible } = useToast()
  const { safeAreaTop } = useViewport()
  const [shouldAnimate, setShouldAnimate] = useState(false)

  // Delay animation trigger to allow initial render in hidden state
  useEffect(() => {
    if (isVisible) {
      const timer = requestAnimationFrame(() => {
        setShouldAnimate(true)
      })
      return () => cancelAnimationFrame(timer)
    }
    setShouldAnimate(false)
    return undefined
  }, [isVisible])

  if (!toast) {
    return null
  }

  return (
    <ToastContainer $isVisible={shouldAnimate} $topOffset={safeAreaTop}>
      <Typography fontSize={14} fontWeight={500} color={colors.white}>
        {toast.message}
      </Typography>
    </ToastContainer>
  )
}

const ToastContainer = styled.div<{ $isVisible: boolean; $topOffset: number }>`
  position: fixed;
  top: ${props => props.$topOffset + 16}px;
  left: 50%;
  transform: translateX(-50%)
    translateY(${props => (props.$isVisible ? '0' : '-100px')});
  z-index: 10000;
  background-color: ${colors.grey800};
  padding: 12px 20px;
  border-radius: ${colors.radiusPill};
  box-shadow: ${colors.shadowLg};
  opacity: ${props => (props.$isVisible ? 1 : 0)};
  transition:
    transform ${ANIMATION_DURATION_S} cubic-bezier(0.4, 0, 0.2, 1),
    opacity ${ANIMATION_DURATION_S} cubic-bezier(0.4, 0, 0.2, 1);
  pointer-events: none;
  max-width: calc(100% - 32px);
  text-align: center;
`
